export const pagesPath = {
  $url: () => `/`,
  features: {
    $url: () => `/features/`,
  },
  tool: {
    $url: () => `/tool/`,
  },
  security: {
    $url: () => `/security/`,
  },
  plan: {
    $url: () => `/plan/`,
  },
  news: {
    $url: () => `/news/`,
    page: {
      _num: (page: string | number) => ({
        $url: () => `/news/page/${page}/`,
      }),
    },
    _category: (_slug: string) => ({
      $url: () => `/news/${_slug}/`,
      page: {
        _num: (page: string | number) => ({
          $url: () => `/news/${_slug}/page/${page}/`,
        }),
      },
    }),
    _contentId: (_id: string) => ({
      $url: () => `/news/${_id}/`,
    }),
  },
  faq: {
    $url: () => `/faq/`,
  },
  rule: {
    $url: () => `/rule/`,
  },
  download: {
    $url: () => `/download/`,
    confirmation: {
      $url: () => `/download/confirmation/`,
    },
    thanks: {
      $url: () => `/download/thanks/`,
    },
  },
  estimate: {
    $url: () => `/estimate/`,
    confirmation: {
      $url: () => `/estimate/confirmation/`,
    },
    thanks: {
      $url: () => `/estimate/thanks/`,
    },
  },
  contact: {
    $url: () => `/contact/`,
    confirmation: {
      $url: () => `/contact/confirmation/`,
    },
    thanks: {
      $url: () => `/contact/thanks/`,
    },
  },
};